import { isMobileDevice } from './device'

export type PlatformOs = 'windows' | 'mac' | 'ios' | 'android' | 'linux' | 'other'

export type PlatformInfo = {
  os: PlatformOs
  isMobile: boolean
  isIos: boolean
  isAndroid: boolean
  isMac: boolean
  isWindows: boolean
  isLinux: boolean
  isSafari: boolean
}

export function getPlatformInfo(): PlatformInfo {
  try {
    const ua = (navigator && navigator.userAgent) ? navigator.userAgent : ''
    const platform = (navigator as any)?.platform || ''
    const maxTouch = (navigator as any)?.maxTouchPoints || 0

    const isAndroid = /android/i.test(ua)
    const isIos = /iPad|iPhone|iPod/.test(ua) || (platform === 'MacIntel' && maxTouch > 1)
    const isWindows = /Win/i.test(platform)
    const isMac = /Mac/i.test(platform) && !isIos
    const isLinux = /Linux/i.test(platform) && !isAndroid
    const isSafari = /safari/i.test(ua) && !/chrome|crios|chromium|fxios|edgios|android/i.test(ua)
    const isMobile = isMobileDevice()

    let os: PlatformOs = 'other'
    if (isIos) os = 'ios'
    else if (isAndroid) os = 'android'
    else if (isWindows) os = 'windows'
    else if (isMac) os = 'mac'
    else if (isLinux) os = 'linux'

    return { os, isMobile, isIos, isAndroid, isMac, isWindows, isLinux, isSafari }
  } catch {
    return {
      os: 'other',
      isMobile: false,
      isIos: false,
      isAndroid: false,
      isMac: false,
      isWindows: false,
      isLinux: false,
      isSafari: false,
    }
  }
}
